export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImNlZGFkZDE3LWNkOGQtMTFlNC04MGM0LTAwMjU5MGQ5ZDVmZiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.Ez6XAdhTvpku8fjl0gzrJeRCpg5OR+L9tAcQXAwq5iFWb2Ze21zJ4lOAqLa4ofMUIqfsmzn0t5Ue/FsnUkM2g8dsT1Lm+ZCNqLJNomdftS03UFNxF/e6TU/LGZVCNQl6/sUL0Q==';
